import { Navigate, Route, Routes, useLocation, useSearchParams } from "react-router-dom"
import { Helmet } from "react-helmet"
import Header from "./components/common/Header"
import BaseLayout from "./components/layout/BaseLayout"
import AddTaskFormular from "./pages/AddTaskFormular"
import "./style/scroll.css"
import { Authorized } from "./auth/Authorized"
import NotAuthorized from "./components/common/NotAuthorized"
import Loading from "./components/common/Loading"
import { useAuth } from "./components/context/AuthContext"
import { useCompanyBranding } from "./components/common/useCompanyBranding"
import { loginPathFor, safeRedirect } from "./auth/redirect"
import Login from "./pages/Login/Login"
import NoCustomer from "./pages/Login/NoCustomer"
import PasswordForgot from "./pages/Passwort/PasswordForgot"
import PasswordSet from "./pages/Passwort/PasswordSet"

// Passwort-Seiten sind öffentlich und auch mit bestehender Anmeldung erreichbar (Einladungslink in einem Browser, in dem schon jemand angemeldet ist).
// Sie werden vor der Auth-Weiche gerendert: ohne Warten auf /portal/auth/session und ohne Umleitung über /login?redirect= (der Token im Fragment läge sonst im Query-String).
const PASSWORD_PATHS = ["/passwort/vergessen", "/passwort/neu"]

function App() {
    const auth = useAuth()
    const location = useLocation()
    if (PASSWORD_PATHS.includes(location.pathname.replace(/\/+$/, ""))) return <PasswordRoutes />
    if (auth.isLoading)
        return (
            <main className="relative overflow-hidden w-screen h-screen">
                <Loading />
            </main>
        )
    if (!auth.isAuthenticated) return <PublicApp />
    if (auth.noCustomer) return <NoCustomer />
    return <AuthenticatedApp />
}

function PasswordRoutes() {
    return (
        <Routes>
            <Route path="/passwort/vergessen" element={<PasswordForgot />} />
            <Route path="/passwort/neu" element={<PasswordSet />} />
        </Routes>
    )
}

// ohne Portal-Anmeldung: nur öffentliche Seiten, alles andere -> /login?redirect=<pfad>
function PublicApp() {
    const location = useLocation()
    return (
        <Routes>
            <Route path="/login" element={<Login />} />
            <Route path="*" element={<Navigate replace to={loginPathFor(location.pathname, location.search, location.hash)} />} />
        </Routes>
    )
}

// nach der Anmeldung zurück auf die ursprünglich angefragte Seite
function LoginRedirect() {
    const [searchParams] = useSearchParams()
    return <Navigate replace to={safeRedirect(searchParams.get("redirect"))} />
}

function AuthenticatedApp() {
    const { companyData, logo } = useCompanyBranding()
    return (
        <main className={"flex flex-col w-full h-screen overflow-hidden bg-base-100"}>
            {/* react-helmet setzt den Titel beim Verlassen der Anmeldeseite nicht zurück */}
            <Helmet>
                <title>Kundenportal | Aufträge</title>
            </Helmet>
            <Header companyData={companyData} logo={logo} />
            <Routes>
                <Route path="/login" element={<LoginRedirect />} />
                <Route
                    path="/"
                    element={
                        <Authorized page allOf={[{ action: "read", subject: "orderRequest" }]}>
                            <AddTaskFormular />
                        </Authorized>
                    }
                />
                <Route path="/404" element={<BaseLayout title="Page Not Found" children={<NotAuthorized />} />} />
                <Route path="*" element={<Navigate to="/404" />} />
            </Routes>
        </main>
    )
}

export default App
